import { AttachFile, Cancel, Close, CloseOutlined, CloseRounded, Delete, ExpandMore, FileOpen, FileUpload, Photo, PhotoCamera, Send } from "@mui/icons-material";
import { Accordion, AccordionDetails, AccordionSummary, Box, Button, CircularProgress, Fab, Grid, IconButton, Stack, Tab, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Tabs, TextField, Tooltip, Typography } from "@mui/material";
import { useContext, useEffect, useState } from "react";
import $data from "../../../services/$data";
import moment from "moment";
import SelectInput from "../../ui/SelectInput";
import { Link } from "react-router-dom";
import BiomassManagement from "./BiomassManagement";
import { animalsInput, fertilizerInput, harvesting, irrigationInput, pesticidesInput, planting, pruning, residuesInput, soilManagement, totalFuel } from "./FarmerInput";
import UploadDocumentModal from "../../ui/UploadDocumentModal";
import DeleteDocumentModal from "../../ui/DeleteDocumentModal";
import { AppContext } from "../../../AppContext";
import { DataContext } from "../../DataContext";
import EmissionConfirmModal from "./EmissionConfirmModal";
import CarbonReportPreview from "../CarbonReportPreview";
import CarbonPhotosModal from "../CarbonPhotosModal";

// Planting => fuel operations
// Fertilizers => fertilizers - records, total emission, fuel operations
// Pesticides => pesticides - category, type, amount, total emission, fuel operations
// Soil management, pruning, harvesting => sve izvuci iz fuel operacija
// Resiudes => residues - management, amount (burned or left), total emission
// Animals => animals - records, total emission - broj dana, tip, broj zivotinja

function CarbonReporting(props) {
  const { selected } = useContext(AppContext);
  const { onGetDocuments, onGetPhotos } = useContext(DataContext);

  const [emissions, setEmissions] = useState([]);
  const [loading, setLoading] = useState(props.parcel.applicabilityStatus === 'Approved');
  const [tab, setTab] = useState(0);

  const [upload, setUpload] = useState(false);
  const [report, setReport] = useState(false);
  const [deleteDoc, setDeleteDoc] = useState(null);
  const [emissionConfirm, setEmissionsConfirm] = useState(null);
  const [photosModal, setPhotosModal] = useState(false);

  const handleTabChange = (event, newValue) => {
    setTab(newValue);
  };
  useEffect(() => {
    getEmissionReports();
    if (props.parcel.applicabilityStatus === 'Approved') {
     
    } else { }
  }, [props.parcel.applicabilityStatus])

  const getEmissionReports = async () => {
    setLoading(true);
    try {
      let records = await $data.getCCRecords(props.parcel.id);
      setEmissions(records);

    } catch (e) {

    } finally {
      setLoading(false);
    }
  }

  const renderDocuments = (tag) => {
    let filtered = props.documents.filter(d => d.tag === tag && d.parcel_id === props.parcel.id);

    if (filtered.length === 0) return 'No documents provided';

    return filtered.map((doc, index) => {
      console.log(doc)
      return (

        <Box key={index} sx={{ position: 'relative', display: 'inline-block' }}>
          <Tooltip title={`Remove document - ${doc.name}`}>
            <IconButton onClick={() => setDeleteDoc(doc.id)} size="small" color="error" sx={{ position: 'absolute', top: -5, left: -5, zIndex: 2 }}><Cancel fontSize="small" /></IconButton>
          </Tooltip>
          <Tooltip title={doc.name}>
            <IconButton LinkComponent={'a'} href={doc.file} target="_blank"><FileOpen fontSize="large" color="warning" /></IconButton>
          </Tooltip>
        </Box>
      )
    })

  }
  const detachPhoto = async (id) => {
    try {
      await $data.updatePhotos([id], null);
      onGetPhotos(selected);
    } catch (error) {
      
    }
  }

  const renderPhotos = (tag) => {
    let filtered = props.photos.filter(p => p.tag === tag && p.parcel === props.parcel.id);
    if (filtered.length === 0) return 'No geo-tagged photos attached';

    return filtered.map((photo, index) => {
      return (
        <Box key={index} sx={{ position: 'relative', display: 'inline-block' }}>
          <Tooltip title={`Detach photo`}>
            <IconButton onClick={() => {detachPhoto(photo.id)}} size="small" color="error" sx={{ position: 'absolute', top: -5, left: -5, zIndex: 2 }}><Cancel fontSize="small" /></IconButton>
          </Tooltip>
          <Tooltip title={photo.name}>
            <IconButton LinkComponent={'a'} href={photo.image} target="_blank"><PhotoCamera fontSize="large" color="blue" /></IconButton>
          </Tooltip>
        </Box>
      )
    })
  }

  const renderFarmerInput = () => {
    let emission = emissions.find(e => e.parcel_id === props.parcel.id && e.year.toString() === props.year);

    if (!Boolean(emission)) {
      return (
        <Stack spacing={1} alignItems="flex-start" justifyContent="flex-start">
          <Typography fontWeight="bold" color="primary">1. Input</Typography>
          <Typography>Provide neccessary input for the monitoring/reporting purposes by <Link style={{ fontWeight: 'bold' }} to={`/dashboard/project/${props.project}/carbon-emissions/new/parcel/${props.parcel.id}/year/${props.year}`}>creating a carbon emission assessment</Link> for selected year ({props.year})</Typography>
        </Stack>
      )
    }
    let status = props.parcel.status.find(s => s.year.toString() === props.year);

    if (status.monitoring === 'Approved') {
      return <Stack spacing={1} alignItems="flex-start" justifyContent="flex-start">
        <Typography fontWeight="bold" color="primary">Emissions report submitted for Verification</Typography>
      </Stack>
    }

    //RETURN MONITORING CATEGORIES PREPOPULATED WITH INPUT FOR PHOTOS AND DOCUMENTS;
    return (
      <Stack spacing={1}>
        <Typography fontWeight="bold" color="primary">1. Input (extracted from carbon emission assessment)</Typography>
        <Stack spacing={1} direction="row">
          <Button onClick={() => setUpload(true)} color="primary" size="small" startIcon={<AttachFile />} variant="contained">Upload document(s)</Button>
          <Button onClick={() => setPhotosModal(true)} color="primary" size="small" variant="contained" startIcon={<PhotoCamera />}>Attach photo(s)</Button>
        </Stack>
        <TableContainer sx={{ '& td': { borderBottom: '1px solid gray', '&:first-of-type': { fontWeight: 'bold' } } }}>
          <Table size="small">
            <TableHead>
              <TableRow>
                <TableCell>Category</TableCell>
                <TableCell>Input</TableCell>
                <TableCell>Proof/Evidence</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              <TableRow>
                <TableCell>Application of fertilizers</TableCell>
                <TableCell>
                  {fertilizerInput(emission.fertilizers, emission.fuel, props.parcel)}
                </TableCell>
                <TableCell>
                  <Stack spacing={2} direction="row" flexWrap="wrap">
                    {renderDocuments('F')}
                  </Stack>
                  <Stack spacing={2} direction="row" flexWrap="wrap">
                    {renderPhotos('F')}
                  </Stack>
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell>Application of pesticides</TableCell>
                <TableCell>
                  {pesticidesInput(emission.pesticides, emission.fuel, props.parcel)}
                </TableCell>
                <TableCell>
                  <Stack spacing={2} direction="row" flexWrap="wrap">
                    {renderDocuments('PE')}
                  </Stack>
                  <Stack spacing={2} direction="row" flexWrap="wrap">
                    {renderPhotos('PE')}
                  </Stack>
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell>Residues management</TableCell>
                <TableCell>
                  {residuesInput(emission.residues)}
                </TableCell>
                <TableCell>
                  <Stack spacing={2} direction="row" flexWrap="wrap">
                    {renderDocuments('RM')}
                  </Stack>
                  <Stack spacing={2} direction="row" flexWrap="wrap">
                    {renderPhotos('RM')}
                  </Stack>
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell>Irrigation</TableCell>
                <TableCell>
                  {irrigationInput(emission.irrigation, props.parcel)}
                </TableCell>
                <TableCell>
                  <Stack spacing={2} direction="row" flexWrap="wrap">
                    {renderDocuments('I')}
                  </Stack>
                  <Stack spacing={2} direction="row" flexWrap="wrap">
                    {renderPhotos('I')}
                  </Stack>
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell>Soil management</TableCell>
                <TableCell>
                  {soilManagement(emission.fuel, props.parcel)}
                </TableCell>
                <TableCell>
                  <Stack spacing={2} direction="row" flexWrap="wrap">
                    {renderDocuments('S')}
                  </Stack>
                  <Stack spacing={2} direction="row" flexWrap="wrap">
                    {renderPhotos('S')}
                  </Stack>
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell>Pruning</TableCell>
                <TableCell>
                  {pruning(emission.fuel, props.parcel)}
                </TableCell>
                <TableCell>
                  <Stack spacing={2} direction="row" flexWrap="wrap">
                    {renderDocuments('PR')}
                  </Stack>
                  <Stack spacing={2} direction="row" flexWrap="wrap">
                    {renderPhotos('PR')}
                  </Stack>
                </TableCell>
              </TableRow>

              <TableRow>
                <TableCell>Harvesting</TableCell>
                <TableCell>
                  {harvesting(emission.fuel, props.parcel)}
                </TableCell>
                <TableCell>
                  <Stack spacing={2} direction="row" flexWrap="wrap">
                    {renderDocuments('H')}
                  </Stack>
                  <Stack spacing={2} direction="row" flexWrap="wrap">
                    {renderPhotos('H')}
                  </Stack>
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell>Animals</TableCell>
                <TableCell>
                  {animalsInput(emission.animals)}
                </TableCell>
                <TableCell>
                  <Stack spacing={2} direction="row" flexWrap="wrap">
                    {renderDocuments('AN')}
                  </Stack>
                  <Stack spacing={2} direction="row" flexWrap="wrap">
                    {renderPhotos('AN')}
                  </Stack>
                </TableCell>
              </TableRow>

              <TableRow>
                <TableCell>Planting</TableCell>
                <TableCell>
                  {planting(emission.fuel, props.parcel)}
                </TableCell>
                <TableCell>
                  <Stack spacing={2} direction="row" flexWrap="wrap">
                    {renderDocuments('PL')}
                  </Stack>
                  <Stack spacing={2} direction="row" flexWrap="wrap">
                    {renderPhotos('PL')}
                  </Stack>
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell>Total fuel</TableCell>
                <TableCell colSpan={2}>
                  {totalFuel(emission.fuel, props.parcel)}
                </TableCell>
              </TableRow>
            </TableBody>
          </Table>
        </TableContainer>
      </Stack>

    );
  }

  // const renderAgriMPInput = () => {
  //   return (
  //     <Stack spacing={1} alignItems="flex-start" justifyContent="flex-start">
  //       <Typography fontWeight="bold" color="primary">2. Soil Sampling Analysis</Typography>

  //       <Typography>Request soil sampling analysis, by providing email of the person in charge of collecting samples</Typography>
  //       <Stack direction="row" spacing={2} alignItems="center">
  //         <TextField size="small" label="Email" type="email"></TextField>
  //         <Button variant="contained" color="primary" size="small" endIcon={<Send fontSize="small" />}>Confirm</Button>
  //       </Stack>
  //     </Stack>
  //   )
  // }

  const renderEmissions = () => {
    if (loading) {
      return (
        <Stack justifyContent="center" alignItems="center">
          <CircularProgress />
        </Stack>
      )
    }

    // if (!props.isEnabled) {
    //   return <Typography>This section will be available, once the parcel passes an applicability check</Typography>
    // }

    return (
      <Grid container spacing={4}>
        <Grid item xs={12}>
          {renderFarmerInput()}
        </Grid>

        <Grid item xs={12} textAlign="center">
          <Button disabled={!props.isEnabled} onClick={() => setEmissionsConfirm(true)} variant="contained">Submit emissions report 2025 for verification</Button>
        </Grid>
        {Boolean(upload) && <UploadDocumentModal open={Boolean(upload)} withoutSOC onClose={() => setUpload(false)} parcel={props.parcel.id} year={props.year} />}
        {Boolean(deleteDoc) && <DeleteDocumentModal open={Boolean(deleteDoc)} documentId={deleteDoc} onClose={() => setDeleteDoc(null)} onDeleteDocument={() => onGetDocuments(selected)} />}
        {Boolean(emissionConfirm) && <EmissionConfirmModal open={emissionConfirm} parcel={props.parcel} year={props.year} onClose={() => setEmissionsConfirm(false)} />}
      </Grid>
    )
  }

  const renderSOC = () => {
    if (loading) {
      return (
        <Stack justifyContent="center" alignItems="center">
          <CircularProgress />
        </Stack>
      )
    }

    // if (!props.isEnabled) {
    //   return <Typography>This section will be available, once the parcel passes an applicability check</Typography>
    // }

    return (
      <Grid container spacing={4}>
        <Grid item xs={12}>
          <Typography>Waiting for Soil Samples Analysis...</Typography>
          <Typography>Once the analysis is complete, you will be able to submit Soil Organic Carbon report for review.</Typography>
        </Grid>
      </Grid>
    );
  }

  const renderBiomassManagement = () => {
    if (loading) {
      return (
        <Stack justifyContent="center" alignItems="center">
          <CircularProgress />
        </Stack>
      )
    }

    // if (!props.isEnabled) {
    //   return <Typography>This section will be available, once the parcel passes an applicability check</Typography>
    // }

    return (
      <Grid container spacing={4}>
        <Grid item xs={12}>
          <BiomassManagement onUpdateParcel={props.onUpdateParcel} photos={props.photos} documents={props.documents} parcel={props.parcel} year={props.year} />
        </Grid>
      </Grid>
    );
  }

  return (
    <>
      <Stack direction="row">
        <Typography color="primary" variant="h5" sx={{ mb: '20px' }} fontWeight={"bold"}>Monitoring/Quantification/Reporting</Typography>
      </Stack>
      <Box sx={{ mt: '20px', mb: '30px' }}>
        <Tabs value={tab} onChange={handleTabChange} aria-label="basic tabs example">
          <Tab sx={{ fontSize: '18px', fontWeight: 'bold' }} value={0} label={`Emissions (${props.year})`} />
          <Tab sx={{ fontSize: '18px', fontWeight: 'bold' }} value={1} label={`Soil Organic Carbon (${props.year})`} />
          <Tab sx={{ fontSize: '18px', fontWeight: 'bold' }} value={2} label={`Biomass Management (${props.year})`} />
        </Tabs>
      </Box>
      {tab === 0 && renderEmissions()}
      {tab === 1 && renderSOC()}
      {tab === 2 && renderBiomassManagement()}
      {/* <Button variant="contained" onClick={() => setReport(true)}>REPORT</Button>
      {report && <CarbonReportPreview documents={props.documents} open={report} emission={emissions.find(e => e.parcel_id === props.parcel.id && e.year.toString() === props.year)} parcel={props.parcel} year={props.year} onClose={() => setReport(false)} />} */}
      {photosModal && <CarbonPhotosModal tags={[
        { value: 'All', label: 'All' },
        { value: 'F', label: 'Fertilization' },
        { value: 'PE', label: 'Pesticides' },
        { value: 'S', label: 'Soil management' },
        { value: 'PR', label: 'Pruning' },
        { value: 'H', label: 'Harvesting' },
        { value: 'RM', label: 'Residues management' },
        { value: 'I', label: 'Irrigation' },
        { value: 'AN', label: 'Animals' },
        { value: 'PL', label: 'Planting' },
      ]} tag={'F'} parcelId={props.parcel.id} year={props.year} onRefreshPhotos={onGetPhotos} selectable projectId={props.parcel.project.id} open={photosModal} photos={props.photos} onClose={() => setPhotosModal(false)} />}
    </>

  )
}

export default CarbonReporting;